<div class="a-w1" style="padding:10px">
    <p-toast key="tl" appendTo="body" position="bottom-right"></p-toast>
    <form [formGroup]="group">
        <div class="a-example-full-width-alterno-content-column">
            <div class="a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select [options]="ListaTipoComprobante" optionLabel="nombre"
                                formControlName="tipocomprobante" optionValue="codigo" appendTo="body" [filter]="true"
                                [showClear]="true" class="w-full md:w-56" (onChange)="getListaSerie(0)">
                            </p-select>
                            <label for="on_label">Tipo Comprobante</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select [options]="ListaSerieComprobante" optionLabel="nombre"
                                formControlName="seriecomprobante" optionValue="codigo" appendTo="body" [filter]="true"
                                [showClear]="true" class="w-full md:w-56" (onChange)="ver($event)">
                            </p-select><!--[readonly]="dropdownSerie" -->
                            <label for="on_label">Serie Comprobante</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-datePicker formControlName="fechaemision" appendTo="body" [showIcon]="true"
                                [showWeek]="false" class="w-full md:w-56" dateFormat="dd/mm/yy">
                            </p-datePicker>
                            <label for="on_label">Fecha Emision</label>
                        </p-floatlabel>
                    </div>
                </div>
            </div>
            <div class="a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select [options]="ListaMoneda" optionLabel="nombre" formControlName="moneda"
                                optionValue="codigo" appendTo="body" [filter]="true" [showClear]="true"
                                [disabled]="true" class="w-full md:w-56">
                            </p-select>
                            <label for="on_label">Moneda</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-select [options]="ListaFormaPago" optionLabel="nombre" formControlName="formapago"
                                optionValue="codigo" appendTo="body" [filter]="true" [showClear]="true"
                                [disabled]="true" class="w-full md:w-56">
                            </p-select>
                            <label for="on_label">Forma Pago</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-inputNumber formControlName="diascredito" mode="decimal" [showButtons]="true"
                                [useGrouping]="false" [min]="0" [inputStyle]="{ width: '100%' }" [disabled]="true">
                            </p-inputNumber>
                            <label for="on_label">Dias Credito</label>
                        </p-floatlabel>
                    </div>
                </div>
            </div>
            <div class="a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-datePicker formControlName="fechavencimiento" appendTo="body" [showIcon]="true"
                                [showWeek]="false" class="w-full md:w-56" dateFormat="dd/mm/yy" [disabled]="true">
                            </p-datePicker>
                            <label for="on_label">Fecha Vencimiento</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-0_5">
                    <div class="a-example-full-width-alterno-content">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <input id="disabled-input" class="w-full md:w-56" type="text" formControlName="viaje"
                                pInputText [readonly]="true" />
                            <label for="on_label">SocioNegocio</label>
                        </p-floatlabel>
                    </div>
                </div>

            </div>
            <div class="a-example-full-width-alterno-content-row">
                <div>
                    <p-button class="butonprefacturar" styleClass="p-button-success" label="Prefacturar"
                        icon="pi pi-dollar"
                        (onClick)="PanelConfirmacionMantenimiento('Está seguro que desea Prefacturar?', this.tablaPrefactura, this.InsertVEN_DOCVSI_UnRegANDVEN_DDOVSI_UnReg.bind(this))"></p-button>
                </div>
            </div>
            <div class="a-w1">
                <app-datatable [dataTable]="datatablePreFac2" [metadataTable]="metadatatablePreFac2" [key]="'key'"></app-datatable>
            </div>
        </div>
    </form>
</div>